/** Let native fields and rich-text editors own their editing shortcuts. */
export const isTextEntryTarget = (target: EventTarget | null): boolean =>
    target instanceof HTMLElement && (target.isContentEditable
        || !!target.closest('input, textarea, select, [contenteditable="true"]'));
